import React, { Suspense } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Tab, Loader as Load, Icon } from "semantic-ui-react";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Converter from "./components/convertidorMedidas";
import Incoterms from "./components/Incoterms";
import Calculador from "./components/calculadora";
import Contenedor from "./components/Contenedor";

function LogisticsTools(props) {
  return (
    <ContentWrapper>
      <div className="content-heading">
        <span className="icon-logistics-tools icon-header" />
        {props.t("logistic_tools")}
      </div>
      <Tab
        loading={true}
        menu={{ secondary: true, pointing: true, className: 'custom-tab-menu' }}
        panes={[
          {
            menuItem: props.t("measurement_convert"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Converter />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("incoterms"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Incoterms />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("cargo_calculator"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Calculador />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("especifications"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Contenedor />
              </Suspense>
            ),
          },
        ]}
      />
      <br></br>
      <br></br>
      <div className='paddin-footer-5em' />
    </ContentWrapper>
  );
}

export default withNamespaces()(withRouter(LogisticsTools));
